import { useState, useEffect } from 'react';
import { api } from '../api';

const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['January','February','March','April','May','June',
                 'July','August','September','October','November','December'];

export default function Holidays() {
  const [holidays, setHolidays] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [form, setForm] = useState({ name: '', holidayDate: '', description: '', holidayType: 'National', academicYear: '2024-25' });
  const [err, setErr] = useState('');

  useEffect(() => {
    api.getHolidaysByYear(year).then(setHolidays);
  }, [year]);

  const load = () => api.getHolidaysByYear(year).then(setHolidays);

  const handleAdd = async () => {
    if (!form.name || !form.holidayDate) { setErr('Name and date required'); return; }
    try {
      await api.createHoliday(form);
      window.location.reload();
    } catch (e) { setErr(e.message); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this holiday?')) return;
    await api.deleteHoliday(id);
    window.location.reload();
  };

  // Build calendar for current month/year
  const firstDay = new Date(year, month - 1, 1).getDay();
  const daysInMonth = new Date(year, month, 0).getDate();
  const today = new Date();

  const holidayMap = {};
  holidays.forEach(h => {
    const d = new Date(h.holidayDate);
    if (d.getMonth() + 1 === month && d.getFullYear() === year) {
      holidayMap[d.getDate()] = h.name;
    }
  });

  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const monthHolidays = holidays.filter(h => {
    const d = new Date(h.holidayDate);
    return d.getMonth() + 1 === month && d.getFullYear() === year;
  });

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
        {/* Calendar */}
        <div className="card">
          <div className="card-header">
            <div className="card-title"><i className="fas fa-calendar-alt" style={{ marginRight: 6 }}></i>{MONTHS[month - 1]} {year}</div>
            <div className="card-actions">
              <select className="form-control" style={{ width: 130 }} value={month} onChange={e => setMonth(parseInt(e.target.value))}>
                {MONTHS.map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
              </select>
              <input className="form-control" type="number" value={year} onChange={e => setYear(parseInt(e.target.value))}
                style={{ width: 90 }} />
            </div>
          </div>
          <div className="card-body">
            <div className="cal-grid">
              {DAY_LABELS.map(d => (
                <div key={d} className="cal-day-name">{d}</div>
              ))}
              {cells.map((d, i) => {
                if (!d) return <div key={`e${i}`} className="cal-day other-month" />;
                const isToday = d === today.getDate() && month === today.getMonth() + 1 && year === today.getFullYear();
                const isSunday = (firstDay + d - 1) % 7 === 0;
                const holiday = holidayMap[d];
                return (
                  <div key={d} className={`cal-day${isToday ? ' today' : ''}${holiday ? ' holiday' : ''}`}>
                    <div className="cal-day-num" style={{ color: isSunday ? '#dc3545' : undefined }}>{d}</div>
                    {holiday && <div className="cal-holiday-label" title={holiday}>{holiday}</div>}
                    {isSunday && !holiday && <div style={{ fontSize: 10, color: '#dc3545' }}>Sunday</div>}
                  </div>
                );
              })}
            </div>

            {monthHolidays.length > 0 && (
              <div style={{ marginTop: 16, padding: 12, background: '#fff8e1', borderRadius: 8 }}>
                <strong style={{ fontSize: 13 }}>Holidays this month:</strong>
                <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                  {monthHolidays.map(h => (
                    <li key={h.id} style={{ fontSize: 12, color: '#555', lineHeight: 1.8 }}>
                      <strong>{new Date(h.holidayDate).getDate()}</strong> — {h.name}
                      <span style={{ marginLeft: 8, fontSize: 11, color: '#999', textTransform: 'capitalize' }}>({h.holidayType})</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Add holiday + list */}
        <div>
          <div className="card">
            <div className="card-header">
              <div className="card-title">Add Holiday</div>
            </div>
            <div className="card-body">
              {err && <div className="error-msg">{err}</div>}
              <div className="form-group">
                <label className="form-label">Holiday Name *</label>
                <input className="form-control" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Date *</label>
                <input className="form-control" type="date" value={form.holidayDate} onChange={e => setForm(f => ({ ...f, holidayDate: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Type</label>
                <select className="form-control" value={form.holidayType} onChange={e => setForm(f => ({ ...f, holidayType: e.target.value }))}>
                  <option value="National">National</option>
                  <option value="Regional">Regional</option>
                  <option value="School">School</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Academic Year</label>
                <input className="form-control" value={form.academicYear} onChange={e => setForm(f => ({ ...f, academicYear: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Description</label>
                <textarea className="form-control" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} style={{ minHeight: 50 }} />
              </div>
              <div className="form-actions">
                <button className="btn btn-primary" onClick={handleAdd}>
                  <i className="fas fa-plus"></i> Add Holiday
                </button>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title">All Holidays {year}</div>
              <div className="card-subtitle">{holidays.length} holidays</div>
            </div>
            <div className="card-body">
              {holidays.length === 0 && <div style={{ color: '#888', fontSize: 13 }}>No holidays added yet</div>}
              {holidays.map(h => (
                <div key={h.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{h.name}</div>
                    <div style={{ fontSize: 11, color: '#888' }}>{h.holidayDate?.split('T')[0]} &bull; <span style={{ textTransform: 'capitalize' }}>{h.holidayType}</span></div>
                  </div>
                  <button className="btn btn-danger btn-sm btn-icon" onClick={() => handleDelete(h.id)} title="Delete">
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
